import type { FaireProductEntity } from "../../entity_types/product";

export const p_s64zjtkks2: FaireProductEntity = {
  token: "p_s64zjtkks2",
  type: "product",
  name: "18K Gold Plated Stainless Steel Wave Zircon Ring – US 7",
  brandToken: "b_wxdny9yjk7",
  brandName: "Norelle",
  imageUrl:
    "https://cdn.faire.com/fastly/42a3b71cc0727c274596f95072e3d8f946b83f7d688339e3cdb03acdd52c25b6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c9b98718845fe201a550765b763fb2aed980187c298786a9e571ce0f91d6ad72.jpeg",
    "https://cdn.faire.com/fastly/2579d910634dc1a072903b2ed3e71bc68a14b41d16bb1e1c80e78e3dc98240ad.jpeg",
    "https://cdn.faire.com/fastly/f14542dd61d63fec3eb52eb38f3fd7219b689e3d50ae95f6e2d5589570a40f27.jpeg",
  ],
  priceDollars: 8,
  description:
    "This minimalist yet striking ring combines sculptural design with timeless sparkle. The open wave band in 18K gold-plated stainless steel cradles a central oval zircon stone, making it a versatile accessory that’s elegant enough for evening wear yet simple for everyday styling.\n\nDurable, waterproof, and hypoallergenic, it offers lasting shine and comfort — a boutique-ready piece with strong gifting and resale potential.\n\n18K gold-plated stainless steel, waterproof and hypoallergenic\nWave-inspired silhouette with oval zircon stone\nTarnish-resistant and lightweight for everyday wear\nA modern statement ring perfect for boutiques and gift shops\n\nMaterial\n18K Gold Plated Stainless Steel\nZircon Stone\n\nDimensions\nRing Size: US 7\n0.68 in (1.73 cm) * 0.63 in (1.60 cm)\nWeight: 0.08 oz (2.2 g)",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:30.168Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
